// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file nodebase/v1/event.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import { EventService } from "./event_pb";

/**
 * @generated from rpc nodebase.v1.EventService.ListEvents
 */
export const listEvents = EventService.method.listEvents;
